module.exports = __webpack_public_path__ + "img/passport.acb41ceb.png";